import React from "react";

const Contact = () => {
  return (
    <div className="bg-[#082028] py-12">
      {" "}
      {/* Updated background color */}
      {/* Title Section */}
      <div className="text-center p-3 mb-12">
        <h1 className="text-2xl text-[#D0B070] md:text-5xl font-bold  drop-shadow-lg">
          {" "}
          {/* Updated title color */}
          Secteurs cibles
        </h1>
      </div>
      <div className="bg-[#082028] pl-8 py-4 md:py-20 md:flex justify-center">
        <div className="grid grid-cols-1 pl-14 md:pl-0  md:grid-cols-2 lg:grid-cols-3 gap-12">
          <div className="group flex flex-col justify-start items-start gap-2 md:w-96 md:h-56 w-[250px] h-[130px] duration-500 relative rounded-lg p-4 bg-[#D0B070] hover:-translate-y-2 hover:shadow-xl shadow-[#505050]">
            {" "}
            {/* Updated to vibrant light color */}
          
            <div>
              <h2 className="text-2xl md:text-5xl text-center font-bold justify-center mt-5  text-[#082028]">
                {" "}
                {/* Updated text color */}
                Résidences privées
              </h2>
              <p className="text-[#082028] text-center text-[10px] md:text-[22px]  line-clamp-3">
                {" "}
                {/* Updated text color */}
                Service à domicile pour les particuliers
              </p>
            </div>
          </div>

          <div className="group flex flex-col justify-start items-start gap-2 md:w-96 md:h-56 w-[250px] h-[130px] duration-500 relative rounded-lg p-4 bg-[#D0B070] hover:-translate-y-2 hover:shadow-xl shadow-[#505050]">
            {" "}
            {/* Updated to vibrant light color */}

            <div>
              <h2 className="text-2xl md:text-5xl text-center font-bold justify-center  mb-2 text-[#082028]">
                {" "}
                {/* Updated text color */}
                Commerces de proximité
              </h2>
              <p className="text-[#082028] text-center text-[10px] md:text-[22px] line-clamp-3">
                {" "}
                {/* Updated text color */}
                Cafés, restaurants, boutiques locales.
              </p>
            </div>
          </div>

          <div className="group flex flex-col justify-start items-start gap-2 md:w-96 md:h-56  w-[250px] h-[130px] duration-500 relative rounded-lg p-4 bg-[#D0B070] hover:-translate-y-2 hover:shadow-xl shadow-[#505050]">
            {" "}
            {/* Updated to vibrant light color */}
         
            <div>
              <h2 className=" text-2xl md:text-5xl  text-center font-bold justify-center mt-2  mb-2 text-[#082028]">
                {" "}
                {/* Updated text color */}
                Écoles et associations locales
              </h2>
              <p className="text-[#082028] text-xl line-clamp-3">
                {" "}
                {/* Updated text color */}
              </p>
            </div>
          </div>

          <div className="group flex flex-col justify-start items-start gap-2 md:w-96 md:h-56  w-[250px] h-[130px] duration-500 relative rounded-lg p-4 bg-[#D0B070] hover:-translate-y-2 hover:shadow-xl shadow-[#505050]">
            {" "}
            {/* Updated to vibrant light color */}
           
            <div>
              <h2 className="text-2xl md:text-4xl text-center font-bold justify-center mt-1 md:mt-5 mb-2 text-[#082028]">
                {" "}
                {/* Updated text color */}
                Petites et moyennes entreprises (PME)
              </h2>
              <p className="text-[#082028] text-xl line-clamp-3">
                {" "}
                {/* Updated text color */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
